import { render, staticRenderFns } from "./grupoPropiedadFamiliaProductoAdd.vue?vue&type=template&id=d8f2b930&scoped=true&"
import script from "./grupoPropiedadFamiliaProductoAdd.vue?vue&type=script&lang=js&"
export * from "./grupoPropiedadFamiliaProductoAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f2b930",
  null
  
)

export default component.exports